var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 37,
    viewBox: "0 0 50 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 33.0007L21.792 35.3898C22.5469 36.4034 23.7363 37.0007 25.0002 37.0007C26.264 37.0007 27.4535 36.4035 28.2083 35.3899L25.0002 33.0007ZM7.20864 2.41238C5.88919 0.640559 3.38322 0.273845 1.6114 1.5933C-0.160415 2.91275 -0.527128 5.41872 0.792325 7.19054L7.20864 2.41238ZM49.2086 7.19058C50.5281 5.41879 50.1614 2.91281 48.3896 1.59333C46.6178 0.273854 44.1118 0.640533 42.7924 2.41233L49.2086 7.19058ZM28.2083 30.6117L7.20864 2.41238L0.792325 7.19054L21.792 35.3898L28.2083 30.6117ZM28.2083 35.3899L49.2086 7.19058L42.7924 2.41233L21.7921 30.6116L28.2083 35.3899Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4694aaec30c75cd3dc6c0328c4607351.svg";
export { ForwardRef as ReactComponent };